@for (link of trackingNumbers; track link) {
  <span class="tracking">
    <a [href]="link.url" target="_blank">{{ link.number }}</a>
  </span>
}
